import React, { useEffect } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import * as productAdminRoleActions from '@/store/productAdminRole/asyncActions';
import * as productAdminRoleSelectors from '@/store/productAdminRole/selectors';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';
import i18n from '@/settings/i18n';
import { RoleList } from '../Presentation';

export const Container: React.FC = () => {
  const dispatch = useAppDispatch();
  const { flashError } = useFlashMessenger();
  const organizationId = useAppSelector(
    authStore.selectors.organizationIdSelector,
  );
  const roles = useAppSelector(
    productAdminRoleSelectors.selectProductAdminRoles,
  );
  const loading = useAppSelector(
    productAdminRoleSelectors.selectProductAdminRolesLoading,
  );

  useEffect(() => {
    if (organizationId) {
      dispatch(
        productAdminRoleActions.fetchRoles({
          organizationId,
        }),
      )
        .then(unwrapResult)
        .catch(() => {
          flashError(i18n.t('ui.error.unexpected'));
        });
    }
  }, [dispatch, organizationId, flashError]);

  return <RoleList roles={roles} loading={loading} />;
};
